import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TelemetryService } from '../../services/telemetry/telemetry.service';

@Injectable()
export class TelemetryInterceptor implements HttpInterceptor {

    constructor(private telemetryService: TelemetryService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const startTime = Date.now();
        const url = request.url;
        const method = request.method;

        return next.handle(request).pipe(
            tap({
                next: (event) => {

                },
                error: (error) => {
                    const duration = Date.now() - startTime;

                    if (error instanceof HttpErrorResponse) {
                        this.trackFailedRequest(method, url, error, duration);
                    } else {
                        this.trackNetworkError(method, url, error, duration);
                    }
                }
            })
        );
    }

    private trackFailedRequest(method: string, url: string, error: HttpErrorResponse, duration: number): void {
        const errorType = this.getErrorType(error.status);

        this.telemetryService.trackCustomEvent('HttpRequestFailed', {
            method,
            url,
            statusCode: error.status,
            statusText: error.statusText,
            errorType,
            duration,
            errorMessage: error.message,
            responseBody: typeof error.error === 'string' ? error.error : JSON.stringify(error.error)
        });

        this.telemetryService.trackError(
            new Error(`HTTP ${error.status} ${errorType}: ${method} ${url}`),
            {
                httpMethod: method,
                httpUrl: url,
                httpStatusCode: error.status,
                httpStatusText: error.statusText,
                duration
            }
        );
    }

    private trackNetworkError(method: string, url: string, error: any, duration: number): void {
        this.telemetryService.trackCustomEvent('HttpNetworkError', {
            method,
            url,
            duration,
            errorMessage: error?.message || 'Network error',
            errorType: 'NetworkError'
        });

        this.telemetryService.trackError(
            new Error(`Network Error: ${method} ${url} - ${error?.message || 'Unknown error'}`),
            {
                httpMethod: method,
                httpUrl: url,
                duration,
                errorType: 'NetworkError'
            }
        );
    }

    private trackSuccessfulRequest(method: string, url: string, statusCode: number, duration: number): void {
        if (duration > 3000) {
            this.telemetryService.trackCustomEvent('HttpRequestSlow', {
                method,
                url,
                statusCode,
                duration
            });
        }
    }

    private getErrorType(statusCode: number): string {
        if (statusCode >= 400 && statusCode < 500) {
            return 'ClientError';
        } else if (statusCode >= 500 && statusCode < 600) {
            return 'ServerError';
        } else {
            return 'UnknownError';
        }
    }
}
